// components/dashboard/DriverStatusPie.jsx
import React from 'react';

const DriverStatusPie = ({ data }) => {
    return (
        <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="text-lg font-medium mb-4">司機狀態分布</h3>
            <div className="h-60 flex items-center justify-center bg-gray-100 rounded">
                <p className="text-gray-500">司機狀態圓餅圖將在此處顯示</p>
            </div>
        </div>
    );
};

export default DriverStatusPie;